export default __webpack_public_path__ + "static/realWorldImg3-89aa5907e856d39ad92cc7663fbab432.png";